import { Modal } from 'antd';
import styled from 'styled-components';

export const PavementProjectsTableModal = styled(Modal)`
  & .ant-modal-content {
    & .ant-modal-header {
      padding: 1rem;
    }
    & .ant-modal-body {
      border: none;
      padding: 0;
      width: 100%;
      padding-left: 0rem;
    }
    & .ant-modal-footer {
      visibility: hidden;
      padding: 0;
    }
  }
`;
